/* unplugin-vue-components disabled */import script from "./SpotItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SpotItem.vue?vue&type=script&setup=true&lang=js"

import "./SpotItem.vue?vue&type=style&index=0&id=1716aaf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1716aaf8"]])

export default __exports__